import styled from 'styled-components';

import { flexCenter, flexStart } from '../../../style/reusableStyle';

export const OnBoardingSidebarStyled = styled.div`
  background: ${({ theme }) => theme.colors.lightBackground};
  max-width: 400px;
  height: 100vh;
  overflow: auto;

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    max-width: 300px;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    max-width: 100%;
    width: 100%;
    height: auto;
  }
`;

export const LogoInfoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 20px 20px;
  margin: 100px 0px 50px;

  & .logo-info {
    p {
      text-align: right;
    }
  }
  & .esc-logo {
    height: 60px;
    width: 60px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    margin: 0px;
    justify-content: start;
    flex-direction: row-reverse;

    & .logo-info {
      p {
        text-align: left;
      }
    }

    & .esc-logo {
      height: 40px;
      width: 40px;
    }
  }
`;

export const StepsContainer = styled.div`
  padding: 0px 20px 0px 80px;

  & .step-number {
    margin-bottom: 10px;
  }
  & .step-desc {
    margin-bottom: 30px;
  }

  & .show-all-steps {
    margin-bottom: 30px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding-left: 30px;

    & .step-desc {
      margin-bottom: 16px;
    }
  }
`;

export const IndividualStep = styled.div<{
  $status?: 'Active' | 'Done' | 'Disabled';
}>`
  ${flexStart};
  gap: 16px;
  margin-bottom: 25px;

  & .step-number {
    ${flexCenter(0)};
    height: 30px;
    width: 30px;
    margin: 0px;
    border-radius: 50%;
    background: ${({ theme, $status }) =>
    $status === 'Done'
      ? theme.colors.secondary
      : $status === 'Active'
        ? theme.colors.yellow.strong
        : theme.colors.disable};
    color: ${({ theme, $status }) =>
    $status === 'Disabled' ? theme.colors.disableText : theme.colors.white};
  }
  & .step-label {
    color: ${({ theme, $status }) =>
    $status === 'Active'
      ? theme.colors.normalText
      : theme.colors.disableText};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-bottom: 16px;
  }
`;
